/* Audit: collection list slider (scroll-snap + arrows) */
(function () {
  function init(root) {
    var track = root.querySelector('[data-dm-cl-track]');
    var prev = root.querySelector('[data-dm-cl-prev]');
    var next = root.querySelector('[data-dm-cl-next]');
    if (!track) return;
    function step() {
      var item = track.querySelector('.collection__item') || track.querySelector(':scope > li');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function isFlickity() { return track.classList.contains('flickity-enabled'); }
    // Infinite scroll (client 2026-10-05): one copy of the items before and after the real ones.
    // Scrolling into a copy is silently moved back by one full set, so the row never ends.
    var loop = root.hasAttribute('data-dm-cl-loop'), looped = false, setW = 0, settleT = 0, holding = false;
    function items() { return Array.prototype.slice.call(track.querySelectorAll(':scope > .collection__item:not([data-dm-clone])')); }
    function makeClone(li) {
      var c = li.cloneNode(true);
      c.setAttribute('data-dm-clone', ''); c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('a, button').forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      c.querySelectorAll('img').forEach(function (img, n) {
        var orig = li.querySelectorAll('img')[n];
        img.removeAttribute('data-rimg'); img.removeAttribute('loading');
        var cur = orig && orig.currentSrc && orig.currentSrc.indexOf('data:') !== 0 ? orig.currentSrc : img.getAttribute('src');
        img.removeAttribute('srcset'); if (cur) img.src = cur;
      });
      c.querySelectorAll('noscript').forEach(function (n) { n.remove(); });
      return c;
    }
    function jump(x) {
      // instant move to the matching item one set away; that position is itself a snap point,
      // so snapping stays on and keeps it there
      try { track.scrollTo({ left: x, behavior: 'instant' }); } catch (e) { track.style.scrollBehavior = 'auto'; track.scrollLeft = x; track.style.scrollBehavior = ''; }
    }
    function measureSet() {
      var first = track.querySelector(':scope > .collection__item:not([data-dm-clone])');
      var after = track.querySelector(':scope > .collection__item[data-dm-clone="after"]');
      return first && after ? after.getBoundingClientRect().left - first.getBoundingClientRect().left : 0;
    }
    function setupLoop() {
      if (!loop || looped || isFlickity() || track.clientWidth === 0) return;
      if (track.scrollWidth - track.clientWidth <= 1) return;           // everything fits: nothing to loop
      var list = items(); if (list.length < 2) return;
      var frag = document.createDocumentFragment();
      list.forEach(function (li) { var c = makeClone(li); c.setAttribute('data-dm-clone', 'before'); frag.appendChild(c); });
      track.insertBefore(frag, list[0]);
      list.forEach(function (li) { var c = makeClone(li); c.setAttribute('data-dm-clone', 'after'); track.appendChild(c); });
      looped = true; root.dataset.dmClLoop = '1';
      setW = measureSet(); jump(track.scrollLeft + setW);
    }
    function settle() {
      if (!looped || holding) return;
      setW = measureSet(); if (!setW) return;
      if (track.scrollLeft < setW * 0.5) jump(track.scrollLeft + setW);
      else if (track.scrollLeft >= setW * 1.5) jump(track.scrollLeft - setW);
    }
    function loopStep(dir) {
      clearTimeout(settleT); settle();                         // re-centre first, then glide one item
      track.scrollTo({ left: track.scrollLeft + dir * step(), behavior: 'smooth' });
    }
    function cells() { return Array.prototype.slice.call(track.querySelectorAll('.flickity-slider > li, .flickity-slider > .collection__item')); }
    function flickityKey(key, code) {
      track.focus({ preventScroll: true });
      track.dispatchEvent(new KeyboardEvent('keydown', { key: key, code: key, keyCode: code, which: code, bubbles: true }));
    }
    function update() {
      if (isFlickity()) {
        var list = cells(); var idx = list.findIndex(function (c) { return c.classList.contains('is-selected'); });
        root.classList.remove('dm-cl--fits');
        if (prev) prev.disabled = idx <= 0;
        if (next) next.disabled = idx >= list.length - 1;
        return;
      }
      setupLoop();
      var max = track.scrollWidth - track.clientWidth - 1;
      var fits = max <= 0;
      root.classList.toggle('dm-cl--fits', fits);
      if (looped) { if (prev) prev.disabled = false; if (next) next.disabled = false; return; }
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { if (isFlickity()) { flickityKey('ArrowLeft', 37); setTimeout(update, 400); } else if (looped) { loopStep(-1); } else { track.scrollBy({ left: -step(), behavior: 'smooth' }); } });
    if (next) next.addEventListener('click', function () { if (isFlickity()) { flickityKey('ArrowRight', 39); setTimeout(update, 400); } else if (looped) { loopStep(1); } else { track.scrollBy({ left: step(), behavior: 'smooth' }); } });
    if (window.MutationObserver) new MutationObserver(function () { update(); }).observe(track, { attributes: true, subtree: true, attributeFilter: ['class'] });
    var hasScrollEnd = 'onscrollend' in window;
    track.addEventListener('scroll', function () { update(); if (looped && !hasScrollEnd) { clearTimeout(settleT); settleT = setTimeout(settle, 250); } }, { passive: true });
    if (hasScrollEnd) track.addEventListener('scrollend', function () { if (looped) settle(); });
    if (loop) {
      track.addEventListener('touchstart', function () { holding = true; clearTimeout(settleT); }, { passive: true });
      track.addEventListener('pointerdown', function () { holding = true; clearTimeout(settleT); });
      ['touchend', 'touchcancel', 'pointerup', 'pointercancel'].forEach(function (ev) {
        track.addEventListener(ev, function () { holding = false; clearTimeout(settleT); settleT = setTimeout(settle, 400); }, { passive: true });
      });
    }
    if (loop) window.addEventListener('resize', function () { setTimeout(settle, 200); });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 500);
    // Sections lower on the page are still hidden (reveal animation) when this runs, so the
    // row measures as 'fits' and both arrows stay disabled. Re-measure once the slider is
    // actually on screen and whenever the user touches it (client 2026-10-01: blog arrows).
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { update(); setTimeout(update, 300); }
      }).observe(root);
    }
    root.addEventListener('pointerdown', update, true);
    root.addEventListener('touchstart', update, { capture: true, passive: true });
  }
  function initAll() {
    document.querySelectorAll('.dm-cl--slider[data-dm-cl]').forEach(function (el) {
      if (el.dataset.dmClReady) return;
      el.dataset.dmClReady = '1';
      init(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
